module.exports = __webpack_public_path__ + "static/media/3.7c89bf35.png";